import { Injectable } from '@angular/core';
import { BaseHttpService } from '@core/http/base-http.service';
import { Config } from '@shared/configs/config';
import {
  ProjectAttachmentLibraryQuery,
  ProjectAttachmentLibraryResponse
} from '../models/project-attachment-library.model';

@Injectable({ providedIn: 'root' })
export class ProjectAttachmentLibraryService extends BaseHttpService {
  getLibrary(query: ProjectAttachmentLibraryQuery) {
    const params: Record<string, string | number | number[]> = {
      ...(query.projectIds?.length ? { 'projectId[]': query.projectIds } : {}),
      ...(query.search?.trim() ? { search: query.search.trim() } : {}),
      ...(query.group ? { group: query.group } : {}),
      ...(query.page ? { page: query.page } : {}),
      ...(query.records ? { records: query.records } : {})
    };

    return this.get<ProjectAttachmentLibraryResponse>(`${Config.API}/attachment/library`, false, params as any);
  }
}
